import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/store'
Vue.use(ElementUI)

import Vuex from 'vuex'
Vue.use(Vuex)

// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;
global.token = 'VrMakerToken'
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");